import Vue from "vue";
import {Environment} from '@/environment/environment';
import * as SentryService from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

const Sentry = {
    init() {
        if (Environment.isProduction()) {
            SentryService.init({
                dsn: 'https://cd53924f1a3542ccac461811319652ea@sentry.jagu.cz/22',
                integrations: [new Integrations.Vue({Vue, attachProps: true})],
            });
        }
    }
};

export default Sentry;
